import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhomSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#FFFAF5] px-4 py-16 md:py-24" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-[#3D2B1F] text-center mb-12 leading-tight" data-id="element-29">
          ¿Para quién es esto?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-30">
          {/* YES - For you */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="bg-[#E8F0E4] rounded-2xl p-6 md:p-8 border border-[#7B9E6B]/20" data-id="element-31">
            <div className="flex items-center gap-2 mb-6" data-id="element-32">
              <span className="text-2xl" data-id="element-33">✅</span>
              <h3 className="text-xl font-bold text-[#3D2B1F]" style={{
              fontFamily: "'DM Serif Display', Georgia, serif"
            }} data-id="element-34">
                Esto ES para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-35">
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.3
            }} className="flex items-start gap-3" data-id="element-36">
                <CheckCircleIcon className="w-5 h-5 text-[#7B9E6B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-37" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-38">
                  Eres padre o madre latina en USA con hijos entre{' '}
                  <strong className="text-[#3D2B1F]" data-id="element-39">2 y 8 años</strong>.
                </span>
              </motion.li>
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.4
            }} className="flex items-start gap-3" data-id="element-40">
                <CheckCircleIcon className="w-5 h-5 text-[#7B9E6B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-41" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-42">
                  Trabajas y llegas a casa con{' '}
                  <strong className="text-[#3D2B1F]" data-id="element-43">
                    poca batería de paciencia
                  </strong>
                  .
                </span>
              </motion.li>
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.5
            }} className="flex items-start gap-3" data-id="element-44">
                <CheckCircleIcon className="w-5 h-5 text-[#7B9E6B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-45" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-46">
                  Quieres{' '}
                  <strong className="text-[#3D2B1F]" data-id="element-47">
                    romper el ciclo generacional
                  </strong>{' '}
                  de gritos en tu familia.
                </span>
              </motion.li>
            </ul>
          </motion.div>

          {/* NO - Not for you */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.25
        }} className="bg-[#FDEAEA] rounded-2xl p-6 md:p-8 border border-[#C44B4B]/10" data-id="element-48">
            <div className="flex items-center gap-2 mb-6" data-id="element-49">
              <span className="text-2xl" data-id="element-50">🛑</span>
              <h3 className="text-xl font-bold text-[#3D2B1F]" style={{
              fontFamily: "'DM Serif Display', Georgia, serif"
            }} data-id="element-51">
                Esto NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-52">
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.4
            }} className="flex items-start gap-3" data-id="element-53">
                <XCircleIcon className="w-5 h-5 text-[#C44B4B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-54" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-55">
                  Buscas una solución mágica sin practicar el autocontrol
                  mínimo.
                </span>
              </motion.li>
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.5
            }} className="flex items-start gap-3" data-id="element-56">
                <XCircleIcon className="w-5 h-5 text-[#C44B4B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-57" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-58">
                  Crees que el castigo físico es la única forma válida de
                  respeto.
                </span>
              </motion.li>
              <motion.li initial={{
              opacity: 0,
              x: -15
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.6
            }} className="flex items-start gap-3" data-id="element-59">
                <XCircleIcon className="w-5 h-5 text-[#C44B4B] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-60" />
                <span className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-61">
                  Prefieres leer teoría académica larga en lugar de herramientas
                  de emergencia de aplicación hoy mismo.
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}